module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3r4n6n9n-39aaf492618a3f53fb799866390356e6.svg";